import * as React from "react";
import "./switch.scss";

const rs = require("react-switch");
// typings are broken
const ReactSwitch: any = rs;

interface IProps {
	/**
	 * Label for switch
	 */
	label?: string;
	/**
	 * On / Off value.
	 */
	checked: boolean;
	/**
	 * Onchange method.
	 * @param checked
	 */
	onChange: (checked: boolean) => void;
	/**
	 * Disabled state
	 */
	disabled?: boolean;
}

export default class Switch extends React.Component<IProps, {}> {
	static defaultProps = {
		disabled: false
	};

	render() {
		return (
			<label htmlFor="material-switch" className={"a-switch"}>
				<span className="a-switch-span">{this.props.label}</span>
				<ReactSwitch
					disabled={this.props.disabled}
					checked={this.props.checked}
					onChange={this.props.onChange}
					onColor="#eb94c2"
					onHandleColor="#b52372"
					handleDiameter={30}
					uncheckedIcon={false}
					checkedIcon={false}
					boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
					activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
					height={20}
					width={48}
					className="react-switch"
					id="material-switch"
				/>
			</label>
		);
	}
}
